@if (comment()) {
  <ng-container
    [ngTemplateOutlet]="commentContent"
    [ngTemplateOutletContext]="{ comment: comment() }"
  >
  </ng-container>
  @for (comment of comment()?.replies; track $index) {
    <ng-container
      [ngTemplateOutlet]="commentContent"
      [ngTemplateOutletContext]="{ comment }"
    >
    </ng-container>
  }
  @if (allowReplies()) {
    <div>
      @if (!isAddingReply() && !issueResolved()) {
        <mat-form-field (click)="enableAddReply()">
          <input matInput placeholder="Reply..." />
        </mat-form-field>
      } @else {
        <div class="comment-status" [class.active]="isSaving()">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        @if (!isEditing() && !issueResolved()) {
          <ng-container [ngTemplateOutlet]="commentFormTemplate"></ng-container>
        }
      }
    </div>
  }
} @else {
  <div class="comment-status" [class.active]="isSaving()">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  @if (!isEditing() && !issueResolved()) {
    <ng-container [ngTemplateOutlet]="commentFormTemplate"></ng-container>
  }
}

<ng-template #commentContent let-comment="comment">
  <div
    class="comment"
    [class.self]="comment.currentUser"
    [class.reply]="comment.parentCommentId"
  >
    <div
      class="comment-status"
      [class.active]="isSaving() && currentComment() === comment"
    >
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div class="comment-header">
      <div class="comment-user-details">
        <div class="author">
          <h4 class="mat-h4">{{ comment.author }}</h4>
          <div class="role">
            <mat-icon>person</mat-icon>
            <span>{{ comment.role }}</span>
          </div>
        </div>
        <div class="date">
          <span>{{
            comment.addedDate + '+0000' | date: 'M/dd/yyyy h:mm:ss a'
          }}</span>
        </div>
      </div>
      @if (!readOnly() && comment.currentUser) {
        <ng-container
          [ngTemplateOutlet]="commentMenu"
          [ngTemplateOutletContext]="{ comment }"
        >
        </ng-container>
      }
    </div>
    <div class="comment-body">
      @if (!isEditing() || currentComment() !== comment) {
        <span>
          {{ comment.comment }}
        </span>
      }
      @if (isEditing() && currentComment() === comment) {
        <ng-container
          [ngTemplateOutlet]="commentFormTemplate"
          [ngTemplateOutletContext]="{ comment }"
        >
        </ng-container>
      }
    </div>
  </div>
</ng-template>

<ng-template #commentFormTemplate let-comment="comment">
  <form
    [formGroup]="commentForm"
    (ngSubmit)="submitComment()"
    [cdkTrapFocus]="isEditing()"
  >
    <input type="hidden" formControlName="id" />
    <fieldset>
      <mat-form-field class="fill-white">
        <textarea
          #textAreaComment
          matInput
          formControlName="comment"
          cdkFocusInitial
          title="Comment"
        ></textarea>
      </mat-form-field>
    </fieldset>
    <div class="form-actions">
      <button
        mat-stroked-button
        color="primary"
        type="submit"
        [disabled]="isSaving() || !textAreaCommentEl()?.nativeElement.value.length"
      >
        Save Comment
      </button>
      @if (comment?.id) {
        <button mat-stroked-button type="button" (click)="disableEditComment()">
          Cancel
        </button>
      }
      @if (isAddingReply()) {
        <button
          mat-stroked-button
          type="button"
          (click)="isAddingReply.set(false)"
        >
          Cancel
        </button>
      }
    </div>
  </form>
</ng-template>

<ng-template #commentMenu let-comment="comment">
  <button mat-icon-button [matMenuTriggerFor]="matMenu">
    <mat-icon>more_horiz</mat-icon>
  </button>
  <mat-menu #matMenu="matMenu">
    <button mat-menu-item (click)="enableEditComment(comment)">
      <mat-icon>edit</mat-icon><span>Edit</span>
    </button>
    <button
      mat-menu-item
      class="delete-button"
      (click)="deleteComment(comment)"
      [disabled]="isDisabled()"
      [matTooltip]="isDisabled() ? 'Your comment cannot be deleted because it has a reply attached to it.' : ''"
    >
      <mat-icon>delete</mat-icon><span>Delete</span>
    </button>
  </mat-menu>
</ng-template>
